import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { EmptyStateSvg } from '@components/empty-state-page/empty-state-svg/empty-state-svg.component';

@Component({
  selector: 'empty-state-page',
  standalone: true,
  imports: [EmptyStateSvg],
  template: `
    <div class="flex h-full flex-col items-center justify-center">
      <empty-state-svg class="mb-3" />
      <p>{{ subTitle() }}</p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStatePage {
  subTitle = input(
    'No results found with the applied filters. Try different terms.'
  );
}
